import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage as Translation } from 'react-intl';
import { formatDate } from 'Helpers/dates';
import { isOutdated } from 'Helpers/adActionStatus';
import css from './AdExpiration.scss';

export const AdExpiration = ({ 'data-aut-id': dataAutId, itemValidTo, status }) => {
    if (!itemValidTo && isOutdated(status)) {
        return null;
    }

    const expireDate = formatDate(new Date(itemValidTo), 'DD/MM/YY');
    const translationsValues = {
        expirationDate: { expirationDate: expireDate }
    };

    return (<div className={ css.adExpiration } data-aut-id={ dataAutId }>
        <Translation id="ad_expiration_item_detail_expiration_date" values={ translationsValues.expirationDate } />
    </div>);
};

AdExpiration.propTypes = {
    itemValidTo: PropTypes.string,
    status: PropTypes.object.isRequired,
    'data-aut-id': PropTypes.string
};

AdExpiration.defaultProps = {
    'data-aut-id': 'adExpiration'
};

export default AdExpiration;
